import React from 'react';
import { Box } from '@chakra-ui/react';

import s from './NoData.module.scss';

type NoDataProps = {
  text: string;
};

export const NoData = ({ text }: NoDataProps): JSX.Element => {
  return (
    <Box as="div" mt={5}>
      <Box as="div" className={s.container}>
        {text}
      </Box>
    </Box>
  );
};
